export default "__VITE_ASSET__BP_ti2Mg__"